import optionsMap from '../../core/helpers/optionsMap.js';
import { INPUT_TYPES } from '../utils/constants.js';
export default {
    title: 'Minimum Item Size',
    description: `Set a minimum item size for items in a group. Note that the size passed to this option is a target size and the gallery will
  try to get as close as possible`,
    type: INPUT_TYPES.NUMBER,
    isRelevant: (options) => options[optionsMap.layoutParams.groups.groupSize] > 1,
    isRelevantDescription: 'Set "Max Group Size" to be greater than "1".',
    default: 120,
};
//# sourceMappingURL=layoutParams_targetItemSize_minimum.js.map